import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { API, errMsg } from "../../lib/api";
import { Field, ErrBox } from "../../components/common";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setErr("Passwords do not match."); return; }
    setBusy(true); setErr("");
    try {
      await API.post("/auth/reset-password", { token: params.get("token"), password });
      navigate("/login");
    } catch (e2) { setErr(errMsg(e2)); setBusy(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-100 px-4">
      <div className="card-gov w-full max-w-md p-6">
        <h1 className="text-xl font-bold text-navy">Set a New Password</h1>
        <form onSubmit={submit} className="mt-4 space-y-4" data-testid="reset-form">
          <Field label="New Password"><input type="password" className="input-gov" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} data-testid="reset-password" /></Field>
          <Field label="Confirm Password"><input type="password" className="input-gov" value={confirm} onChange={(e) => setConfirm(e.target.value)} required data-testid="reset-confirm" /></Field>
          <ErrBox msg={err} />
          <button className="btn-navy w-full" disabled={busy} data-testid="reset-submit">{busy ? "Updating…" : "Update Password"}</button>
        </form>
        <Link to="/login" className="mt-4 block text-center text-sm font-semibold text-navy hover:underline">Back to sign in</Link>
      </div>
    </div>
  );
}
